(() => {
  // source/js/modules/example.js
  var Example = class {
    constructor(element) {
      this.element = element;
      this.init();
    }
    init() {
      console.log("MODULE EXAMPLE INIT");
    }
  };
  var example = {
    init() {
      const exampleElements = document.querySelectorAll('[data-module="example"]');
      if (null !== exampleElements && exampleElements.length > 0) {
        exampleElements.forEach((element) => {
          new Example(element);
        });
      }
    }
  };
  var example_default = example;

  // source/js/main.js
  var Application = class {
    constructor() {
      document.addEventListener("DOMContentLoaded", () => {
        example_default.init();
      });
    }
  };
  new Application();
})();
